// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"517":"aa61c8ad","606":"31b71112"}[chunkId] + ".chunk.js";
};